// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3UJZX","box":"WorkspacesBox_box__kNer8","node":"WorkspacesBox_node__14wTf"};